if (!customElements.get('hero-slider')) {
  class HeroSlider extends HTMLElement {
    constructor() {
      super();
      this.click = false;
      this.$slider = false;
      this.init = false;
      this.$navItems = this.querySelectorAll('.slider-nav__item');
      this.$playPause = this.querySelector('.slider__pause');      
      this.$slides = this.querySelectorAll('.hero-slider__slide');
      this.count = this.$slides.length;
      this.paused = false;
      this.loaded = false;
      if( !this.$navItems.length)
        return;

      var self = this;
      this.$navItems.forEach($elm => {
        $elm.addEventListener('click', self.onNavClick.bind(this));
      });

      var $firstSlide = this.$slides[0];

      if( $firstSlide.hasAttribute('data-video') ){
        const $video = $firstSlide.querySelector('.hero-slider__video');
        this.buildVideo($video);
      }

      this.navActiveClass = 'js-slider-nav-active';  

      document.addEventListener('js-window-interact', this.initSlider.bind(this), {once: true});

      this.$playPause.addEventListener( 'click', (event) => {
        if( this.paused ){
          this.playSlider();
        }else{
          this.pauseSlider();
        }
      });
    }

    initSlider() {
      const autoplay = this.hasAttribute('data-autoplay') && this.hasAttribute('data-speed') ? this.getAttribute('data-speed'): false;

      let $slider = new Glide(this, {
        type: 'carousel',
        autoplay: autoplay,
        hoverpause: false,
        gap: 0,
        keyboard: false
      });

      var self = this;
      $slider.on('run.before', function(e){
        const navCount = self.$navItems.length - 1;
        const dir = e.direction == ">" ? 1 : -1; 
        let index = $slider.index + dir;
        if( navCount == $slider.index && e.direction == ">" ){
          index = 0
        }else if( $slider.index == 0 && e.direction == "<" ){
          index = navCount;          
        } 

        if( !self.click ){
          self.setActiveSlide(index);          
        }
      });

      $slider.on('run.after', function(){
        const $currentSlide = self.querySelectorAll(`.hero-slider__slide:not(.glide__slide--clone)`)[$slider.index];
        self.playVideo( $currentSlide );
        self.setTabableElements( $slider.index );
      });

      $slider.on('mount.after', function(){
        const $currentSlide = self.querySelectorAll(`.hero-slider__slide:not(.glide__slide--clone)`)[$slider.index];
        self.classList.add( 'glide-active') ;
        self.prepareVideos();
        self.setTabableElements( $slider.index );
      });

      $slider.mount();

      this.addEventListener('keydown', function( e ){
        const curIndex = $slider.index;

        let nextIndex = false;
        if( e.key === "ArrowRight" ){
          if( curIndex === this.count - 1 ){
            nextIndex = 0;
          }else{
            nextIndex = curIndex + 1;            
          }
          nextIndex = curIndex === ( this.count - 1 ) ? 0 : curIndex + 1; 
        }else if( e.key === "ArrowLeft" ){
          nextIndex = curIndex === 0 ? ( this.count - 1 ) : curIndex - 1; 
        }

        if( nextIndex || nextIndex === 0 ){  
          this.click = true;
          this.setActiveSlide(nextIndex);
          this.click = false;
          // this.announceSlideChange(nextIndex + 1, this.count, "");
        }
      });

      this.addEventListener('focusin', ( e ) => {
        if( e.target === this.$playPause )
          return false;

        self.pauseSlider();
      });

      this.$slider = $slider;

      this.loaded = true;
    }

    setTabableElements( currentSlideIndex = false ) {
      if( !this.loaded ){
          const $clones = this.querySelectorAll('.hero-slider__slide.glide__slide--clone');
          $clones.forEach( $clone => {
            $clone.setAttribute('aria-hidden', true);
            $clone.setAttribute('tabindex', -1);

            const $tab_items = $clone.querySelectorAll('a, button');
            $tab_items.forEach( $item => {
              $item.setAttribute('tabindex', -1);
              $item.setAttribute('aria-hidden', true);              
            });
          });
      }

      this.$slides.forEach( ($slide, index) => {
        const $tab_items = $slide.querySelectorAll('a, button');
        $slide.setAttribute('tabindex', -1);
        $slide.setAttribute('aria-hidden', true);

        $tab_items.forEach( $item => {
          if( index == currentSlideIndex ){
            $item.setAttribute('tabindex', 0);
            $item.setAttribute('aria-hidden', false);
          }else{
            $item.setAttribute('tabindex', -1);
            $item.setAttribute('aria-hidden', true);
          }
        });

      }); 
    }

    onNavClick(e) {
      this.click = true;
      const $elm = e.currentTarget;
      const itr = $elm.getAttribute('rel');

      this.setActiveSlide(itr);

      this.click = false;
    }

    setActiveSlide(itr) {
      this.resetNavItems();
      this.setActiveNavItem(itr);
      this.$slider.go(`=${itr}`);
    }

    setActiveNavItem(itr) {
      this
        .$navItems[itr]
        .classList
        .add(this.navActiveClass);
    }

    resetNavItems() {
      this.$navItems.forEach($elm => {
        $elm.classList.remove(this.navActiveClass);
      });            
    }

    prepareVideos() {
      const $slides = this.querySelectorAll('.hero-slider__slide');

      const self = this;
      $slides.forEach(($elm, index) => {
        const $video = $elm.querySelector('.hero-slider__video');

        if( $video ){
          var video = self.buildVideo($video);

          if( $elm.classList.contains('glide__slide--active') ){
            self.playVideo($elm);
          }

        }
      });
    }

    pauseSlider() {
      this.$slider.pause();
      this.$playPause.setAttribute('aria-pressed', true);
      this.paused = true;
    }

    playSlider() {
      this.$slider.play();
      this.$playPause.setAttribute('aria-pressed', false);
      this.paused = false;
    }

    buildVideo($video) {
        let video = document.createElement('video');
        video.src = $video.getAttribute('data-src');
        video.playsinline = true;
        video.loop = true;
        video.setAttribute('muted', "");
        video.setAttribute('playsinline', "");
        video.muted = true;
        video.setAttribute('aria-hidden', true);

        $video.append(video);
    }

    announceSlideChange(index, total, label) {
      const status = this.querySelector('.slider-status');
      status.innerText = `Slide ${index} of ${total}${label ? ':' + label : "" }`;
    }

    playVideo($slide) {
      const $video = $slide.querySelector('.hero-slider__video video');
      if( $video ){
        $video.play();
      }
    }
  }

  customElements.define('hero-slider', HeroSlider);
}